import {
  Companion_getInstance1b21bhtdgqkve as Companion_getInstance,
  Contractor1wog4uk4l8u77 as Contractor,
  Companion_instance3eje2t5q7hpt as Companion_instance,
  ShortId1uz90q3uk7eoq as ShortId,
} from './databaseModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Addresscpovxna1tjmg as Address } from './supportModels.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import {
  KtSetjrjc7fhfd6b9 as KtSet,
  KtList3hktaavzmj137 as KtList,
} from '../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance_0,
  UUID21wrnrlmk5y1y as UUID,
} from '../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { ServerFile1t91jzpzoixwe as ServerFile } from '../../../lightning-server-shared/com/lightningkite/lightningserver/files/ServerFile.mjs';
import {
  PreferredTitle_Contractor_getInstance1vu9hnmofbdy6 as PreferredTitle_Contractor_getInstance,
  PreferredTitle2hv2nwg5p3fmp as PreferredTitle,
  ContractorStatus_Registering_getInstance9wzvdghru4x2 as ContractorStatus_Registering_getInstance,
  ContractorStatus22amkaqyvz8q1 as ContractorStatus,
} from './enums.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance_0 } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../lightning-server-shared/com/lightningkite/DefaultClock.mjs';
import { Instant3cn81rq2kpflk as Instant } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_name(_this__u8e3s4) {
  return _this__u8e3s4.prop(Contractor_name_getInstance());
}
function get_contactFirstName(_this__u8e3s4) {
  return _this__u8e3s4.prop(Contractor_contactFirstName_getInstance());
}
function get_contactLastName(_this__u8e3s4) {
  return _this__u8e3s4.prop(Contractor_contactLastName_getInstance());
}
function get_contactEmail(_this__u8e3s4) {
  return _this__u8e3s4.prop(Contractor_contactEmail_getInstance());
}
function get_contactPhoneNumber(_this__u8e3s4) {
  return _this__u8e3s4.prop(Contractor_contactPhoneNumber_getInstance());
}
function get_legalName(_this__u8e3s4) {
  return _this__u8e3s4.prop(Contractor_legalName_getInstance());
}
function get_email(_this__u8e3s4) {
  return _this__u8e3s4.prop(Contractor_email_getInstance());
}
function get_phoneNumber(_this__u8e3s4) {
  return _this__u8e3s4.prop(Contractor_phoneNumber_getInstance());
}
function get_contactAddress(_this__u8e3s4) {
  return _this__u8e3s4.prop(Contractor_contactAddress_getInstance());
}
function get_operationStates(_this__u8e3s4) {
  return _this__u8e3s4.prop(Contractor_operationStates_getInstance());
}
function get_trade(_this__u8e3s4) {
  return _this__u8e3s4.prop(Contractor_trade_getInstance());
}
function get_annualRevenue(_this__u8e3s4) {
  return _this__u8e3s4.prop(Contractor_annualRevenue_getInstance());
}
function get_averageJobSize(_this__u8e3s4) {
  return _this__u8e3s4.prop(Contractor_averageJobSize_getInstance());
}
function get_employeeCount(_this__u8e3s4) {
  return _this__u8e3s4.prop(Contractor_employeeCount_getInstance());
}
function get_otherBusinessData(_this__u8e3s4) {
  return _this__u8e3s4.prop(Contractor_otherBusinessData_getInstance());
}
function get_entityType(_this__u8e3s4) {
  return _this__u8e3s4.prop(Contractor_entityType_getInstance());
}
function get_address(_this__u8e3s4) {
  return _this__u8e3s4.prop(Contractor_address_getInstance());
}
function get_ein(_this__u8e3s4) {
  return _this__u8e3s4.prop(Contractor_ein_getInstance());
}
function get_stateEntityNumber(_this__u8e3s4) {
  return _this__u8e3s4.prop(Contractor_stateEntityNumber_getInstance());
}
function get_owners(_this__u8e3s4) {
  return _this__u8e3s4.prop(Contractor_owners_getInstance());
}
function get__id(_this__u8e3s4) {
  return _this__u8e3s4.prop(Contractor__id_getInstance());
}
function prepareContractorFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [Contractor__id_getInstance(), Contractor_shortId_getInstance(), Contractor_name_getInstance(), Contractor_legalName_getInstance(), Contractor_email_getInstance(), Contractor_phoneNumber_getInstance(), Contractor_address_getInstance(), Contractor_image_getInstance(), Contractor_preferredTitle_getInstance(), Contractor_trade_getInstance(), Contractor_entityType_getInstance(), Contractor_contactFirstName_getInstance(), Contractor_contactLastName_getInstance(), Contractor_contactEmail_getInstance(), Contractor_contactPhoneNumber_getInstance(), Contractor_contactAddress_getInstance(), Contractor_operationStates_getInstance(), Contractor_annualRevenue_getInstance(), Contractor_averageJobSize_getInstance(), Contractor_employeeCount_getInstance(), Contractor_otherBusinessData_getInstance(), Contractor_stateEntityNumber_getInstance(), Contractor_ein_getInstance(), Contractor_owners_getInstance(), Contractor_status_getInstance(), Contractor_paymentId_getInstance(), Contractor_created_getInstance(), Contractor_readBy_getInstance()];
  var tmp = Companion_getInstance().m2a();
  properties(tmp, (it) => props);
}
function Contractor_name$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(2);
}
function Contractor_name$_get_name_$ref_97et7m() {
  return (p0) => p0.k20();
}
function Contractor_name$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Contractor_name$_get_serializer_$ref_jk8wdz() {
  return (p0) => p0.j2j();
}
function Contractor_name$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(2);
}
function Contractor_name$_get_annotations_$ref_m32dpp() {
  return (p0) => p0.bz();
}
var Contractor_nameClass;
function Contractor_name() {
  if (Contractor_nameClass === VOID) {
    class $ {
      constructor() {
        Contractor_name_instance = this;
        var tmp = this;
        tmp.r5i_1 = lazy(Contractor_name$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.s5i_1 = lazy(Contractor_name$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.t5i_1 = lazy(Contractor_name$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.r5i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Contractor_name$_get_name_$ref_97et7m(), null);
        return tmp0.f2();
      }
      u5i(receiver) {
        return receiver.x5i_1;
      }
      m2j(receiver) {
        return this.u5i(receiver instanceof Contractor() ? receiver : THROW_CCE());
      }
      x5j(receiver, value) {
        return receiver.y5j(VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Contractor() ? receiver : THROW_CCE();
        return this.x5j(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.s5i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Contractor_name$_get_serializer_$ref_jk8wdz(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.t5i_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Contractor_name$_get_annotations_$ref_m32dpp(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Contractor_name', VOID, VOID, [SerializableProperty()]);
    Contractor_nameClass = $;
  }
  return Contractor_nameClass;
}
var Contractor_name_instance;
function Contractor_name_getInstance() {
  if (Contractor_name_instance === VOID)
    new (Contractor_name())();
  return Contractor_name_instance;
}
function Contractor_contactFirstName$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(11);
}
function Contractor_contactFirstName$_get_name_$ref_2fy2ha() {
  return (p0) => p0.k20();
}
function Contractor_contactFirstName$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[11];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Contractor_contactFirstName$_get_serializer_$ref_t75wtj() {
  return (p0) => p0.j2j();
}
function Contractor_contactFirstName$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(11);
}
function Contractor_contactFirstName$_get_annotations_$ref_yc2irn() {
  return (p0) => p0.bz();
}
var Contractor_contactFirstNameClass;
function Contractor_contactFirstName() {
  if (Contractor_contactFirstNameClass === VOID) {
    class $ {
      constructor() {
        Contractor_contactFirstName_instance = this;
        var tmp = this;
        tmp.z5j_1 = lazy(Contractor_contactFirstName$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.a5k_1 = lazy(Contractor_contactFirstName$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.b5k_1 = lazy(Contractor_contactFirstName$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.z5j_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Contractor_contactFirstName$_get_name_$ref_2fy2ha(), null);
        return tmp0.f2();
      }
      u5i(receiver) {
        return receiver.g5j_1;
      }
      m2j(receiver) {
        return this.u5i(receiver instanceof Contractor() ? receiver : THROW_CCE());
      }
      x5j(receiver, value) {
        return receiver.y5j(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Contractor() ? receiver : THROW_CCE();
        return this.x5j(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.a5k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Contractor_contactFirstName$_get_serializer_$ref_t75wtj(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.b5k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Contractor_contactFirstName$_get_annotations_$ref_yc2irn(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Contractor_contactFirstName', VOID, VOID, [SerializableProperty()]);
    Contractor_contactFirstNameClass = $;
  }
  return Contractor_contactFirstNameClass;
}
var Contractor_contactFirstName_instance;
function Contractor_contactFirstName_getInstance() {
  if (Contractor_contactFirstName_instance === VOID)
    new (Contractor_contactFirstName())();
  return Contractor_contactFirstName_instance;
}
function Contractor_contactLastName$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(12);
}
function Contractor_contactLastName$_get_name_$ref_jpiq9o() {
  return (p0) => p0.k20();
}
function Contractor_contactLastName$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[12];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Contractor_contactLastName$_get_serializer_$ref_ntdigb() {
  return (p0) => p0.j2j();
}
function Contractor_contactLastName$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(12);
}
function Contractor_contactLastName$_get_annotations_$ref_qxwn67() {
  return (p0) => p0.bz();
}
var Contractor_contactLastNameClass;
function Contractor_contactLastName() {
  if (Contractor_contactLastNameClass === VOID) {
    class $ {
      constructor() {
        Contractor_contactLastName_instance = this;
        var tmp = this;
        tmp.c5k_1 = lazy(Contractor_contactLastName$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.d5k_1 = lazy(Contractor_contactLastName$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.e5k_1 = lazy(Contractor_contactLastName$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.c5k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Contractor_contactLastName$_get_name_$ref_jpiq9o(), null);
        return tmp0.f2();
      }
      u5i(receiver) {
        return receiver.h5j_1;
      }
      m2j(receiver) {
        return this.u5i(receiver instanceof Contractor() ? receiver : THROW_CCE());
      }
      x5j(receiver, value) {
        return receiver.y5j(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Contractor() ? receiver : THROW_CCE();
        return this.x5j(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.d5k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Contractor_contactLastName$_get_serializer_$ref_ntdigb(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.e5k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Contractor_contactLastName$_get_annotations_$ref_qxwn67(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Contractor_contactLastName', VOID, VOID, [SerializableProperty()]);
    Contractor_contactLastNameClass = $;
  }
  return Contractor_contactLastNameClass;
}
var Contractor_contactLastName_instance;
function Contractor_contactLastName_getInstance() {
  if (Contractor_contactLastName_instance === VOID)
    new (Contractor_contactLastName())();
  return Contractor_contactLastName_instance;
}
function Contractor_contactEmail$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(13);
}
function Contractor_contactEmail$_get_name_$ref_utme99() {
  return (p0) => p0.k20();
}
function Contractor_contactEmail$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[13];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Contractor_contactEmail$_get_serializer_$ref_h7krp6() {
  return (p0) => p0.j2j();
}
function Contractor_contactEmail$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(13);
}
function Contractor_contactEmail$_get_annotations_$ref_imbim6() {
  return (p0) => p0.bz();
}
var Contractor_contactEmailClass;
function Contractor_contactEmail() {
  if (Contractor_contactEmailClass === VOID) {
    class $ {
      constructor() {
        Contractor_contactEmail_instance = this;
        var tmp = this;
        tmp.f5k_1 = lazy(Contractor_contactEmail$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.g5k_1 = lazy(Contractor_contactEmail$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.h5k_1 = lazy(Contractor_contactEmail$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.f5k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Contractor_contactEmail$_get_name_$ref_utme99(), null);
        return tmp0.f2();
      }
      u5i(receiver) {
        return receiver.i5j_1;
      }
      m2j(receiver) {
        return this.u5i(receiver instanceof Contractor() ? receiver : THROW_CCE());
      }
      x5j(receiver, value) {
        return receiver.y5j(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Contractor() ? receiver : THROW_CCE();
        return this.x5j(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.g5k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Contractor_contactEmail$_get_serializer_$ref_h7krp6(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.h5k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Contractor_contactEmail$_get_annotations_$ref_imbim6(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Contractor_contactEmail', VOID, VOID, [SerializableProperty()]);
    Contractor_contactEmailClass = $;
  }
  return Contractor_contactEmailClass;
}
var Contractor_contactEmail_instance;
function Contractor_contactEmail_getInstance() {
  if (Contractor_contactEmail_instance === VOID)
    new (Contractor_contactEmail())();
  return Contractor_contactEmail_instance;
}
function Contractor_contactPhoneNumber$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(14);
}
function Contractor_contactPhoneNumber$_get_name_$ref_15kbv6() {
  return (p0) => p0.k20();
}
function Contractor_contactPhoneNumber$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[14];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Contractor_contactPhoneNumber$_get_serializer_$ref_to4t5h() {
  return (p0) => p0.j2j();
}
function Contractor_contactPhoneNumber$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(14);
}
function Contractor_contactPhoneNumber$_get_annotations_$ref_chdgjr() {
  return (p0) => p0.bz();
}
var Contractor_contactPhoneNumberClass;
function Contractor_contactPhoneNumber() {
  if (Contractor_contactPhoneNumberClass === VOID) {
    class $ {
      constructor() {
        Contractor_contactPhoneNumber_instance = this;
        var tmp = this;
        tmp.i5k_1 = lazy(Contractor_contactPhoneNumber$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.j5k_1 = lazy(Contractor_contactPhoneNumber$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.k5k_1 = lazy(Contractor_contactPhoneNumber$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.i5k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Contractor_contactPhoneNumber$_get_name_$ref_15kbv6(), null);
        return tmp0.f2();
      }
      u5i(receiver) {
        return receiver.j5j_1;
      }
      m2j(receiver) {
        return this.u5i(receiver instanceof Contractor() ? receiver : THROW_CCE());
      }
      x5j(receiver, value) {
        return receiver.y5j(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Contractor() ? receiver : THROW_CCE();
        return this.x5j(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.j5k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Contractor_contactPhoneNumber$_get_serializer_$ref_to4t5h(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.k5k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Contractor_contactPhoneNumber$_get_annotations_$ref_chdgjr(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Contractor_contactPhoneNumber', VOID, VOID, [SerializableProperty()]);
    Contractor_contactPhoneNumberClass = $;
  }
  return Contractor_contactPhoneNumberClass;
}
var Contractor_contactPhoneNumber_instance;
function Contractor_contactPhoneNumber_getInstance() {
  if (Contractor_contactPhoneNumber_instance === VOID)
    new (Contractor_contactPhoneNumber())();
  return Contractor_contactPhoneNumber_instance;
}
function Contractor_legalName$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(3);
}
function Contractor_legalName$_get_name_$ref_w9mrpj() {
  return (p0) => p0.k20();
}
function Contractor_legalName$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Contractor_legalName$_get_serializer_$ref_xgf3ce() {
  return (p0) => p0.j2j();
}
function Contractor_legalName$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(3);
}
function Contractor_legalName$_get_annotations_$ref_c7zvg2() {
  return (p0) => p0.bz();
}
var Contractor_legalNameClass;
function Contractor_legalName() {
  if (Contractor_legalNameClass === VOID) {
    class $ {
      constructor() {
        Contractor_legalName_instance = this;
        var tmp = this;
        tmp.l5k_1 = lazy(Contractor_legalName$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.m5k_1 = lazy(Contractor_legalName$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.n5k_1 = lazy(Contractor_legalName$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.l5k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Contractor_legalName$_get_name_$ref_w9mrpj(), null);
        return tmp0.f2();
      }
      u5i(receiver) {
        return receiver.y5i_1;
      }
      m2j(receiver) {
        return this.u5i(receiver instanceof Contractor() ? receiver : THROW_CCE());
      }
      x5j(receiver, value) {
        return receiver.y5j(VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Contractor() ? receiver : THROW_CCE();
        return this.x5j(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.m5k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Contractor_legalName$_get_serializer_$ref_xgf3ce(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.n5k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Contractor_legalName$_get_annotations_$ref_c7zvg2(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Contractor_legalName', VOID, VOID, [SerializableProperty()]);
    Contractor_legalNameClass = $;
  }
  return Contractor_legalNameClass;
}
var Contractor_legalName_instance;
function Contractor_legalName_getInstance() {
  if (Contractor_legalName_instance === VOID)
    new (Contractor_legalName())();
  return Contractor_legalName_instance;
}
function Contractor_email$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(4);
}
function Contractor_email$_get_name_$ref_9o9unz() {
  return (p0) => p0.k20();
}
function Contractor_email$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Contractor_email$_get_serializer_$ref_tr8zve() {
  return (p0) => p0.j2j();
}
function Contractor_email$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(4);
}
function Contractor_email$_get_annotations_$ref_h1ew5y() {
  return (p0) => p0.bz();
}
var Contractor_emailClass;
function Contractor_email() {
  if (Contractor_emailClass === VOID) {
    class $ {
      constructor() {
        Contractor_email_instance = this;
        var tmp = this;
        tmp.o5k_1 = lazy(Contractor_email$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.p5k_1 = lazy(Contractor_email$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.q5k_1 = lazy(Contractor_email$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.o5k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Contractor_email$_get_name_$ref_9o9unz(), null);
        return tmp0.f2();
      }
      u5i(receiver) {
        return receiver.z5i_1;
      }
      m2j(receiver) {
        return this.u5i(receiver instanceof Contractor() ? receiver : THROW_CCE());
      }
      x5j(receiver, value) {
        return receiver.y5j(VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Contractor() ? receiver : THROW_CCE();
        return this.x5j(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.p5k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Contractor_email$_get_serializer_$ref_tr8zve(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.q5k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Contractor_email$_get_annotations_$ref_h1ew5y(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Contractor_email', VOID, VOID, [SerializableProperty()]);
    Contractor_emailClass = $;
  }
  return Contractor_emailClass;
}
var Contractor_email_instance;
function Contractor_email_getInstance() {
  if (Contractor_email_instance === VOID)
    new (Contractor_email())();
  return Contractor_email_instance;
}
function Contractor_phoneNumber$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(5);
}
function Contractor_phoneNumber$_get_name_$ref_mwpyje() {
  return (p0) => p0.k20();
}
function Contractor_phoneNumber$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[5];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Contractor_phoneNumber$_get_serializer_$ref_z6pq9r() {
  return (p0) => p0.j2j();
}
function Contractor_phoneNumber$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(5);
}
function Contractor_phoneNumber$_get_annotations_$ref_97rq91() {
  return (p0) => p0.bz();
}
var Contractor_phoneNumberClass;
function Contractor_phoneNumber() {
  if (Contractor_phoneNumberClass === VOID) {
    class $ {
      constructor() {
        Contractor_phoneNumber_instance = this;
        var tmp = this;
        tmp.r5k_1 = lazy(Contractor_phoneNumber$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.s5k_1 = lazy(Contractor_phoneNumber$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.t5k_1 = lazy(Contractor_phoneNumber$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.r5k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Contractor_phoneNumber$_get_name_$ref_mwpyje(), null);
        return tmp0.f2();
      }
      u5i(receiver) {
        return receiver.a5j_1;
      }
      m2j(receiver) {
        return this.u5i(receiver instanceof Contractor() ? receiver : THROW_CCE());
      }
      x5j(receiver, value) {
        return receiver.y5j(VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Contractor() ? receiver : THROW_CCE();
        return this.x5j(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.s5k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Contractor_phoneNumber$_get_serializer_$ref_z6pq9r(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.t5k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Contractor_phoneNumber$_get_annotations_$ref_97rq91(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Contractor_phoneNumber', VOID, VOID, [SerializableProperty()]);
    Contractor_phoneNumberClass = $;
  }
  return Contractor_phoneNumberClass;
}
var Contractor_phoneNumber_instance;
function Contractor_phoneNumber_getInstance() {
  if (Contractor_phoneNumber_instance === VOID)
    new (Contractor_phoneNumber())();
  return Contractor_phoneNumber_instance;
}
function Contractor_contactAddress$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(15);
}
function Contractor_contactAddress$_get_name_$ref_gcrefp() {
  return (p0) => p0.k20();
}
function Contractor_contactAddress$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[15];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Contractor_contactAddress$_get_serializer_$ref_g5oys2() {
  return (p0) => p0.j2j();
}
function Contractor_contactAddress$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(15);
}
function Contractor_contactAddress$_get_annotations_$ref_jsemui() {
  return (p0) => p0.bz();
}
var Contractor_contactAddressClass;
function Contractor_contactAddress() {
  if (Contractor_contactAddressClass === VOID) {
    class $ {
      constructor() {
        Contractor_contactAddress_instance = this;
        var tmp = this;
        tmp.u5k_1 = lazy(Contractor_contactAddress$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.v5k_1 = lazy(Contractor_contactAddress$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.w5k_1 = lazy(Contractor_contactAddress$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.u5k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Contractor_contactAddress$_get_name_$ref_gcrefp(), null);
        return tmp0.f2();
      }
      u5i(receiver) {
        return receiver.k5j_1;
      }
      m2j(receiver) {
        return this.u5i(receiver instanceof Contractor() ? receiver : THROW_CCE());
      }
      x5k(receiver, value) {
        return receiver.y5j(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Contractor() ? receiver : THROW_CCE();
        return this.x5k(tmp, value instanceof Address() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.v5k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Contractor_contactAddress$_get_serializer_$ref_g5oys2(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.w5k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Contractor_contactAddress$_get_annotations_$ref_jsemui(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Contractor_contactAddress', VOID, VOID, [SerializableProperty()]);
    Contractor_contactAddressClass = $;
  }
  return Contractor_contactAddressClass;
}
var Contractor_contactAddress_instance;
function Contractor_contactAddress_getInstance() {
  if (Contractor_contactAddress_instance === VOID)
    new (Contractor_contactAddress())();
  return Contractor_contactAddress_instance;
}
function Contractor_operationStates$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(16);
}
function Contractor_operationStates$_get_name_$ref_u6varw() {
  return (p0) => p0.k20();
}
function Contractor_operationStates$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[16];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Contractor_operationStates$_get_serializer_$ref_ks58t() {
  return (p0) => p0.j2j();
}
function Contractor_operationStates$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(16);
}
function Contractor_operationStates$_get_annotations_$ref_1sjg2f() {
  return (p0) => p0.bz();
}
var Contractor_operationStatesClass;
function Contractor_operationStates() {
  if (Contractor_operationStatesClass === VOID) {
    class $ {
      constructor() {
        Contractor_operationStates_instance = this;
        var tmp = this;
        tmp.y5k_1 = lazy(Contractor_operationStates$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.z5k_1 = lazy(Contractor_operationStates$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.a5l_1 = lazy(Contractor_operationStates$annotations$delegate$lambda);
        var tmp_2 = this;
        // Inline function 'kotlin.collections.setOf' call
        tmp_2.b5l_1 = emptySet();
        this.c5l_1 = 'setOf()';
      }
      k20() {
        var tmp0 = this.y5k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Contractor_operationStates$_get_name_$ref_u6varw(), null);
        return tmp0.f2();
      }
      u5i(receiver) {
        return receiver.l5j_1;
      }
      m2j(receiver) {
        return this.u5i(receiver instanceof Contractor() ? receiver : THROW_CCE());
      }
      d5l(receiver, value) {
        return receiver.y5j(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Contractor() ? receiver : THROW_CCE();
        return this.d5l(tmp, (!(value == null) ? isInterface(value, KtSet()) : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.z5k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Contractor_operationStates$_get_serializer_$ref_ks58t(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.a5l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Contractor_operationStates$_get_annotations_$ref_1sjg2f(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Contractor_operationStates', VOID, VOID, [SerializableProperty()]);
    Contractor_operationStatesClass = $;
  }
  return Contractor_operationStatesClass;
}
var Contractor_operationStates_instance;
function Contractor_operationStates_getInstance() {
  if (Contractor_operationStates_instance === VOID)
    new (Contractor_operationStates())();
  return Contractor_operationStates_instance;
}
function Contractor_trade$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(9);
}
function Contractor_trade$_get_name_$ref_kmsbbb() {
  return (p0) => p0.k20();
}
function Contractor_trade$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[9];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Contractor_trade$_get_serializer_$ref_1ayvji() {
  return (p0) => p0.j2j();
}
function Contractor_trade$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(9);
}
function Contractor_trade$_get_annotations_$ref_ehdto2() {
  return (p0) => p0.bz();
}
var Contractor_tradeClass;
function Contractor_trade() {
  if (Contractor_tradeClass === VOID) {
    class $ {
      constructor() {
        Contractor_trade_instance = this;
        var tmp = this;
        tmp.e5l_1 = lazy(Contractor_trade$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.f5l_1 = lazy(Contractor_trade$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.g5l_1 = lazy(Contractor_trade$annotations$delegate$lambda);
        this.h5l_1 = null;
        this.i5l_1 = 'null';
      }
      k20() {
        var tmp0 = this.e5l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Contractor_trade$_get_name_$ref_kmsbbb(), null);
        return tmp0.f2();
      }
      u5i(receiver) {
        return receiver.e5j_1;
      }
      m2j(receiver) {
        return this.u5i(receiver instanceof Contractor() ? receiver : THROW_CCE());
      }
      j5l(receiver, value) {
        return receiver.y5j(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Contractor() ? receiver : THROW_CCE();
        return this.j5l(tmp, (value == null ? true : typeof value === 'string') ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.f5l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Contractor_trade$_get_serializer_$ref_1ayvji(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.g5l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Contractor_trade$_get_annotations_$ref_ehdto2(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Contractor_trade', VOID, VOID, [SerializableProperty()]);
    Contractor_tradeClass = $;
  }
  return Contractor_tradeClass;
}
var Contractor_trade_instance;
function Contractor_trade_getInstance() {
  if (Contractor_trade_instance === VOID)
    new (Contractor_trade())();
  return Contractor_trade_instance;
}
function Contractor_annualRevenue$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(17);
}
function Contractor_annualRevenue$_get_name_$ref_r4uchs() {
  return (p0) => p0.k20();
}
function Contractor_annualRevenue$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[17];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Contractor_annualRevenue$_get_serializer_$ref_qxh7qf() {
  return (p0) => p0.j2j();
}
function Contractor_annualRevenue$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(17);
}
function Contractor_annualRevenue$_get_annotations_$ref_1ftxfv() {
  return (p0) => p0.bz();
}
var Contractor_annualRevenueClass;
function Contractor_annualRevenue() {
  if (Contractor_annualRevenueClass === VOID) {
    class $ {
      constructor() {
        Contractor_annualRevenue_instance = this;
        var tmp = this;
        tmp.k5l_1 = lazy(Contractor_annualRevenue$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.l5l_1 = lazy(Contractor_annualRevenue$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.m5l_1 = lazy(Contractor_annualRevenue$annotations$delegate$lambda);
        this.n5l_1 = null;
        this.o5l_1 = 'null';
      }
      k20() {
        var tmp0 = this.k5l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Contractor_annualRevenue$_get_name_$ref_r4uchs(), null);
        return tmp0.f2();
      }
      u5i(receiver) {
        return receiver.m5j_1;
      }
      m2j(receiver) {
        return this.u5i(receiver instanceof Contractor() ? receiver : THROW_CCE());
      }
      p5l(receiver, value) {
        return receiver.y5j(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Contractor() ? receiver : THROW_CCE();
        return this.p5l(tmp, (value == null ? true : typeof value === 'number') ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.l5l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Contractor_annualRevenue$_get_serializer_$ref_qxh7qf(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.m5l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Contractor_annualRevenue$_get_annotations_$ref_1ftxfv(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Contractor_annualRevenue', VOID, VOID, [SerializableProperty()]);
    Contractor_annualRevenueClass = $;
  }
  return Contractor_annualRevenueClass;
}
var Contractor_annualRevenue_instance;
function Contractor_annualRevenue_getInstance() {
  if (Contractor_annualRevenue_instance === VOID)
    new (Contractor_annualRevenue())();
  return Contractor_annualRevenue_instance;
}
function Contractor_averageJobSize$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(18);
}
function Contractor_averageJobSize$_get_name_$ref_vxev88() {
  return (p0) => p0.k20();
}
function Contractor_averageJobSize$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[18];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Contractor_averageJobSize$_get_serializer_$ref_ieqczl() {
  return (p0) => p0.j2j();
}
function Contractor_averageJobSize$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(18);
}
function Contractor_averageJobSize$_get_annotations_$ref_dnwbod() {
  return (p0) => p0.bz();
}
var Contractor_averageJobSizeClass;
function Contractor_averageJobSize() {
  if (Contractor_averageJobSizeClass === VOID) {
    class $ {
      constructor() {
        Contractor_averageJobSize_instance = this;
        var tmp = this;
        tmp.q5l_1 = lazy(Contractor_averageJobSize$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.r5l_1 = lazy(Contractor_averageJobSize$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.s5l_1 = lazy(Contractor_averageJobSize$annotations$delegate$lambda);
        this.t5l_1 = null;
        this.u5l_1 = 'null';
      }
      k20() {
        var tmp0 = this.q5l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Contractor_averageJobSize$_get_name_$ref_vxev88(), null);
        return tmp0.f2();
      }
      u5i(receiver) {
        return receiver.n5j_1;
      }
      m2j(receiver) {
        return this.u5i(receiver instanceof Contractor() ? receiver : THROW_CCE());
      }
      p5l(receiver, value) {
        return receiver.y5j(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Contractor() ? receiver : THROW_CCE();
        return this.p5l(tmp, (value == null ? true : typeof value === 'number') ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.r5l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Contractor_averageJobSize$_get_serializer_$ref_ieqczl(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.s5l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Contractor_averageJobSize$_get_annotations_$ref_dnwbod(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Contractor_averageJobSize', VOID, VOID, [SerializableProperty()]);
    Contractor_averageJobSizeClass = $;
  }
  return Contractor_averageJobSizeClass;
}
var Contractor_averageJobSize_instance;
function Contractor_averageJobSize_getInstance() {
  if (Contractor_averageJobSize_instance === VOID)
    new (Contractor_averageJobSize())();
  return Contractor_averageJobSize_instance;
}
function Contractor_employeeCount$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(19);
}
function Contractor_employeeCount$_get_name_$ref_6ti9a4() {
  return (p0) => p0.k20();
}
function Contractor_employeeCount$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[19];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Contractor_employeeCount$_get_serializer_$ref_2sprxn() {
  return (p0) => p0.j2j();
}
function Contractor_employeeCount$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(19);
}
function Contractor_employeeCount$_get_annotations_$ref_vss2i9() {
  return (p0) => p0.bz();
}
var Contractor_employeeCountClass;
function Contractor_employeeCount() {
  if (Contractor_employeeCountClass === VOID) {
    class $ {
      constructor() {
        Contractor_employeeCount_instance = this;
        var tmp = this;
        tmp.v5l_1 = lazy(Contractor_employeeCount$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.w5l_1 = lazy(Contractor_employeeCount$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.x5l_1 = lazy(Contractor_employeeCount$annotations$delegate$lambda);
        this.y5l_1 = null;
        this.z5l_1 = 'null';
      }
      k20() {
        var tmp0 = this.v5l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Contractor_employeeCount$_get_name_$ref_6ti9a4(), null);
        return tmp0.f2();
      }
      u5i(receiver) {
        return receiver.o5j_1;
      }
      m2j(receiver) {
        return this.u5i(receiver instanceof Contractor() ? receiver : THROW_CCE());
      }
      p5l(receiver, value) {
        return receiver.y5j(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Contractor() ? receiver : THROW_CCE();
        return this.p5l(tmp, (value == null ? true : typeof value === 'number') ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.w5l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Contractor_employeeCount$_get_serializer_$ref_2sprxn(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.x5l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Contractor_employeeCount$_get_annotations_$ref_vss2i9(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Contractor_employeeCount', VOID, VOID, [SerializableProperty()]);
    Contractor_employeeCountClass = $;
  }
  return Contractor_employeeCountClass;
}
var Contractor_employeeCount_instance;
function Contractor_employeeCount_getInstance() {
  if (Contractor_employeeCount_instance === VOID)
    new (Contractor_employeeCount())();
  return Contractor_employeeCount_instance;
}
function Contractor_otherBusinessData$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(20);
}
function Contractor_otherBusinessData$_get_name_$ref_2xv737() {
  return (p0) => p0.k20();
}
function Contractor_otherBusinessData$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[20];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Contractor_otherBusinessData$_get_serializer_$ref_s0olks() {
  return (p0) => p0.j2j();
}
function Contractor_otherBusinessData$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(20);
}
function Contractor_otherBusinessData$_get_annotations_$ref_44uo8() {
  return (p0) => p0.bz();
}
var Contractor_otherBusinessDataClass;
function Contractor_otherBusinessData() {
  if (Contractor_otherBusinessDataClass === VOID) {
    class $ {
      constructor() {
        Contractor_otherBusinessData_instance = this;
        var tmp = this;
        tmp.a5m_1 = lazy(Contractor_otherBusinessData$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.b5m_1 = lazy(Contractor_otherBusinessData$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.c5m_1 = lazy(Contractor_otherBusinessData$annotations$delegate$lambda);
        this.d5m_1 = null;
        this.e5m_1 = 'null';
      }
      k20() {
        var tmp0 = this.a5m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Contractor_otherBusinessData$_get_name_$ref_2xv737(), null);
        return tmp0.f2();
      }
      u5i(receiver) {
        return receiver.p5j_1;
      }
      m2j(receiver) {
        return this.u5i(receiver instanceof Contractor() ? receiver : THROW_CCE());
      }
      j5l(receiver, value) {
        return receiver.y5j(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Contractor() ? receiver : THROW_CCE();
        return this.j5l(tmp, (value == null ? true : typeof value === 'string') ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.b5m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Contractor_otherBusinessData$_get_serializer_$ref_s0olks(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.c5m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Contractor_otherBusinessData$_get_annotations_$ref_44uo8(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Contractor_otherBusinessData', VOID, VOID, [SerializableProperty()]);
    Contractor_otherBusinessDataClass = $;
  }
  return Contractor_otherBusinessDataClass;
}
var Contractor_otherBusinessData_instance;
function Contractor_otherBusinessData_getInstance() {
  if (Contractor_otherBusinessData_instance === VOID)
    new (Contractor_otherBusinessData())();
  return Contractor_otherBusinessData_instance;
}
function Contractor_entityType$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(10);
}
function Contractor_entityType$_get_name_$ref_babz2s() {
  return (p0) => p0.k20();
}
function Contractor_entityType$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[10];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Contractor_entityType$_get_serializer_$ref_t6tgfv() {
  return (p0) => p0.j2j();
}
function Contractor_entityType$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(10);
}
function Contractor_entityType$_get_annotations_$ref_2fehi7() {
  return (p0) => p0.bz();
}
var Contractor_entityTypeClass;
function Contractor_entityType() {
  if (Contractor_entityTypeClass === VOID) {
    class $ {
      constructor() {
        Contractor_entityType_instance = this;
        var tmp = this;
        tmp.f5m_1 = lazy(Contractor_entityType$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.g5m_1 = lazy(Contractor_entityType$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.h5m_1 = lazy(Contractor_entityType$annotations$delegate$lambda);
        this.i5m_1 = null;
        this.j5m_1 = 'null';
      }
      k20() {
        var tmp0 = this.f5m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Contractor_entityType$_get_name_$ref_babz2s(), null);
        return tmp0.f2();
      }
      u5i(receiver) {
        return receiver.f5j_1;
      }
      m2j(receiver) {
        return this.u5i(receiver instanceof Contractor() ? receiver : THROW_CCE());
      }
      j5l(receiver, value) {
        return receiver.y5j(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Contractor() ? receiver : THROW_CCE();
        return this.j5l(tmp, (value == null ? true : typeof value === 'string') ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.g5m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Contractor_entityType$_get_serializer_$ref_t6tgfv(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.h5m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Contractor_entityType$_get_annotations_$ref_2fehi7(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Contractor_entityType', VOID, VOID, [SerializableProperty()]);
    Contractor_entityTypeClass = $;
  }
  return Contractor_entityTypeClass;
}
var Contractor_entityType_instance;
function Contractor_entityType_getInstance() {
  if (Contractor_entityType_instance === VOID)
    new (Contractor_entityType())();
  return Contractor_entityType_instance;
}
function Contractor_address$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(6);
}
function Contractor_address$_get_name_$ref_nkna21() {
  return (p0) => p0.k20();
}
function Contractor_address$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[6];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Contractor_address$_get_serializer_$ref_ewd6ma() {
  return (p0) => p0.j2j();
}
function Contractor_address$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(6);
}
function Contractor_address$_get_annotations_$ref_jkzate() {
  return (p0) => p0.bz();
}
var Contractor_addressClass;
function Contractor_address() {
  if (Contractor_addressClass === VOID) {
    class $ {
      constructor() {
        Contractor_address_instance = this;
        var tmp = this;
        tmp.k5m_1 = lazy(Contractor_address$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.l5m_1 = lazy(Contractor_address$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.m5m_1 = lazy(Contractor_address$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.k5m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Contractor_address$_get_name_$ref_nkna21(), null);
        return tmp0.f2();
      }
      u5i(receiver) {
        return receiver.b5j_1;
      }
      m2j(receiver) {
        return this.u5i(receiver instanceof Contractor() ? receiver : THROW_CCE());
      }
      x5k(receiver, value) {
        return receiver.y5j(VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Contractor() ? receiver : THROW_CCE();
        return this.x5k(tmp, value instanceof Address() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.l5m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Contractor_address$_get_serializer_$ref_ewd6ma(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.m5m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Contractor_address$_get_annotations_$ref_jkzate(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Contractor_address', VOID, VOID, [SerializableProperty()]);
    Contractor_addressClass = $;
  }
  return Contractor_addressClass;
}
var Contractor_address_instance;
function Contractor_address_getInstance() {
  if (Contractor_address_instance === VOID)
    new (Contractor_address())();
  return Contractor_address_instance;
}
function Contractor_ein$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(22);
}
function Contractor_ein$_get_name_$ref_vwuy6r() {
  return (p0) => p0.k20();
}
function Contractor_ein$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[22];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Contractor_ein$_get_serializer_$ref_712ofg() {
  return (p0) => p0.j2j();
}
function Contractor_ein$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(22);
}
function Contractor_ein$_get_annotations_$ref_b9q754() {
  return (p0) => p0.bz();
}
var Contractor_einClass;
function Contractor_ein() {
  if (Contractor_einClass === VOID) {
    class $ {
      constructor() {
        Contractor_ein_instance = this;
        var tmp = this;
        tmp.n5m_1 = lazy(Contractor_ein$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.o5m_1 = lazy(Contractor_ein$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.p5m_1 = lazy(Contractor_ein$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.n5m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Contractor_ein$_get_name_$ref_vwuy6r(), null);
        return tmp0.f2();
      }
      u5i(receiver) {
        return receiver.r5j_1;
      }
      m2j(receiver) {
        return this.u5i(receiver instanceof Contractor() ? receiver : THROW_CCE());
      }
      x5j(receiver, value) {
        return receiver.y5j(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Contractor() ? receiver : THROW_CCE();
        return this.x5j(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.o5m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Contractor_ein$_get_serializer_$ref_712ofg(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.p5m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Contractor_ein$_get_annotations_$ref_b9q754(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Contractor_ein', VOID, VOID, [SerializableProperty()]);
    Contractor_einClass = $;
  }
  return Contractor_einClass;
}
var Contractor_ein_instance;
function Contractor_ein_getInstance() {
  if (Contractor_ein_instance === VOID)
    new (Contractor_ein())();
  return Contractor_ein_instance;
}
function Contractor_stateEntityNumber$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(21);
}
function Contractor_stateEntityNumber$_get_name_$ref_myjtc0() {
  return (p0) => p0.k20();
}
function Contractor_stateEntityNumber$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[21];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Contractor_stateEntityNumber$_get_serializer_$ref_i4rk2v() {
  return (p0) => p0.j2j();
}
function Contractor_stateEntityNumber$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(21);
}
function Contractor_stateEntityNumber$_get_annotations_$ref_9yix6d() {
  return (p0) => p0.bz();
}
var Contractor_stateEntityNumberClass;
function Contractor_stateEntityNumber() {
  if (Contractor_stateEntityNumberClass === VOID) {
    class $ {
      constructor() {
        Contractor_stateEntityNumber_instance = this;
        var tmp = this;
        tmp.q5m_1 = lazy(Contractor_stateEntityNumber$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.r5m_1 = lazy(Contractor_stateEntityNumber$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.s5m_1 = lazy(Contractor_stateEntityNumber$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.q5m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Contractor_stateEntityNumber$_get_name_$ref_myjtc0(), null);
        return tmp0.f2();
      }
      u5i(receiver) {
        return receiver.q5j_1;
      }
      m2j(receiver) {
        return this.u5i(receiver instanceof Contractor() ? receiver : THROW_CCE());
      }
      x5j(receiver, value) {
        return receiver.y5j(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Contractor() ? receiver : THROW_CCE();
        return this.x5j(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.r5m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Contractor_stateEntityNumber$_get_serializer_$ref_i4rk2v(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.s5m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Contractor_stateEntityNumber$_get_annotations_$ref_9yix6d(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Contractor_stateEntityNumber', VOID, VOID, [SerializableProperty()]);
    Contractor_stateEntityNumberClass = $;
  }
  return Contractor_stateEntityNumberClass;
}
var Contractor_stateEntityNumber_instance;
function Contractor_stateEntityNumber_getInstance() {
  if (Contractor_stateEntityNumber_instance === VOID)
    new (Contractor_stateEntityNumber())();
  return Contractor_stateEntityNumber_instance;
}
function Contractor_owners$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(23);
}
function Contractor_owners$_get_name_$ref_670wyx() {
  return (p0) => p0.k20();
}
function Contractor_owners$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[23];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Contractor_owners$_get_serializer_$ref_7jiz9a() {
  return (p0) => p0.j2j();
}
function Contractor_owners$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(23);
}
function Contractor_owners$_get_annotations_$ref_y7esea() {
  return (p0) => p0.bz();
}
var Contractor_ownersClass;
function Contractor_owners() {
  if (Contractor_ownersClass === VOID) {
    class $ {
      constructor() {
        Contractor_owners_instance = this;
        var tmp = this;
        tmp.t5m_1 = lazy(Contractor_owners$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.u5m_1 = lazy(Contractor_owners$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.v5m_1 = lazy(Contractor_owners$annotations$delegate$lambda);
        var tmp_2 = this;
        // Inline function 'kotlin.collections.listOf' call
        tmp_2.w5m_1 = emptyList();
        this.x5m_1 = 'listOf()';
      }
      k20() {
        var tmp0 = this.t5m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Contractor_owners$_get_name_$ref_670wyx(), null);
        return tmp0.f2();
      }
      u5i(receiver) {
        return receiver.s5j_1;
      }
      m2j(receiver) {
        return this.u5i(receiver instanceof Contractor() ? receiver : THROW_CCE());
      }
      y5m(receiver, value) {
        return receiver.y5j(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Contractor() ? receiver : THROW_CCE();
        return this.y5m(tmp, (!(value == null) ? isInterface(value, KtList()) : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.u5m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Contractor_owners$_get_serializer_$ref_7jiz9a(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.v5m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Contractor_owners$_get_annotations_$ref_y7esea(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Contractor_owners', VOID, VOID, [SerializableProperty()]);
    Contractor_ownersClass = $;
  }
  return Contractor_ownersClass;
}
var Contractor_owners_instance;
function Contractor_owners_getInstance() {
  if (Contractor_owners_instance === VOID)
    new (Contractor_owners())();
  return Contractor_owners_instance;
}
function Contractor__id$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(0);
}
function Contractor__id$_get_name_$ref_26waw3() {
  return (p0) => p0.k20();
}
function Contractor__id$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Contractor__id$_get_serializer_$ref_4f2a10() {
  return (p0) => p0.j2j();
}
function Contractor__id$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(0);
}
function Contractor__id$_get_annotations_$ref_b0flfc() {
  return (p0) => p0.bz();
}
var Contractor__idClass;
function Contractor__id() {
  if (Contractor__idClass === VOID) {
    class $ {
      constructor() {
        Contractor__id_instance = this;
        var tmp = this;
        tmp.z5m_1 = lazy(Contractor__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.a5n_1 = lazy(Contractor__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.b5n_1 = lazy(Contractor__id$annotations$delegate$lambda);
        this.c5n_1 = Companion_getInstance_0().m2p();
        this.d5n_1 = 'UUID.random()';
      }
      k20() {
        var tmp0 = this.z5m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Contractor__id$_get_name_$ref_26waw3(), null);
        return tmp0.f2();
      }
      u5i(receiver) {
        return receiver.v5i_1;
      }
      m2j(receiver) {
        return this.u5i(receiver instanceof Contractor() ? receiver : THROW_CCE());
      }
      e5n(receiver, value) {
        return receiver.y5j(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Contractor() ? receiver : THROW_CCE();
        return this.e5n(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.a5n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Contractor__id$_get_serializer_$ref_4f2a10(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.b5n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Contractor__id$_get_annotations_$ref_b0flfc(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Contractor__id', VOID, VOID, [SerializableProperty()]);
    Contractor__idClass = $;
  }
  return Contractor__idClass;
}
var Contractor__id_instance;
function Contractor__id_getInstance() {
  if (Contractor__id_instance === VOID)
    new (Contractor__id())();
  return Contractor__id_instance;
}
function Contractor_shortId$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(1);
}
function Contractor_shortId$_get_name_$ref_idfgm() {
  return (p0) => p0.k20();
}
function Contractor_shortId$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Contractor_shortId$_get_serializer_$ref_c6bti9() {
  return (p0) => p0.j2j();
}
function Contractor_shortId$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(1);
}
function Contractor_shortId$_get_annotations_$ref_wmsumd() {
  return (p0) => p0.bz();
}
var Contractor_shortIdClass;
function Contractor_shortId() {
  if (Contractor_shortIdClass === VOID) {
    class $ {
      constructor() {
        Contractor_shortId_instance = this;
        var tmp = this;
        tmp.f5n_1 = lazy(Contractor_shortId$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.g5n_1 = lazy(Contractor_shortId$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.h5n_1 = lazy(Contractor_shortId$annotations$delegate$lambda);
        this.i5n_1 = Companion_instance.k5n();
        this.j5n_1 = 'ShortId.random()';
      }
      k20() {
        var tmp0 = this.f5n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Contractor_shortId$_get_name_$ref_idfgm(), null);
        return tmp0.f2();
      }
      l5n(receiver) {
        return receiver.w5i_1;
      }
      m2j(receiver) {
        return new (ShortId())(this.l5n(receiver instanceof Contractor() ? receiver : THROW_CCE()));
      }
      m5n(receiver, value) {
        return receiver.y5j(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Contractor() ? receiver : THROW_CCE();
        return this.m5n(tmp, value instanceof ShortId() ? value.n5n_1 : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.g5n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Contractor_shortId$_get_serializer_$ref_c6bti9(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.h5n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Contractor_shortId$_get_annotations_$ref_wmsumd(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Contractor_shortId', VOID, VOID, [SerializableProperty()]);
    Contractor_shortIdClass = $;
  }
  return Contractor_shortIdClass;
}
var Contractor_shortId_instance;
function Contractor_shortId_getInstance() {
  if (Contractor_shortId_instance === VOID)
    new (Contractor_shortId())();
  return Contractor_shortId_instance;
}
function Contractor_image$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(7);
}
function Contractor_image$_get_name_$ref_mdmjvi() {
  return (p0) => p0.k20();
}
function Contractor_image$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[7];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Contractor_image$_get_serializer_$ref_dhfdbv() {
  return (p0) => p0.j2j();
}
function Contractor_image$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(7);
}
function Contractor_image$_get_annotations_$ref_oa4x5j() {
  return (p0) => p0.bz();
}
var Contractor_imageClass;
function Contractor_image() {
  if (Contractor_imageClass === VOID) {
    class $ {
      constructor() {
        Contractor_image_instance = this;
        var tmp = this;
        tmp.o5n_1 = lazy(Contractor_image$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.p5n_1 = lazy(Contractor_image$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.q5n_1 = lazy(Contractor_image$annotations$delegate$lambda);
        this.r5n_1 = null;
        this.s5n_1 = 'null';
      }
      k20() {
        var tmp0 = this.o5n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Contractor_image$_get_name_$ref_mdmjvi(), null);
        return tmp0.f2();
      }
      t5n(receiver) {
        return receiver.c5j_1;
      }
      m2j(receiver) {
        var tmp = this.t5n(receiver instanceof Contractor() ? receiver : THROW_CCE());
        return tmp == null ? null : new (ServerFile())(tmp);
      }
      u5n(receiver, value) {
        return receiver.y5j(VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Contractor() ? receiver : THROW_CCE();
        var tmp_0;
        if (value == null ? true : value instanceof ServerFile()) {
          var tmp_1 = value;
          tmp_0 = tmp_1 == null ? null : tmp_1.n2n_1;
        } else {
          tmp_0 = THROW_CCE();
        }
        return this.u5n(tmp, tmp_0);
      }
      j2j() {
        var tmp0 = this.p5n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Contractor_image$_get_serializer_$ref_dhfdbv(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.q5n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Contractor_image$_get_annotations_$ref_oa4x5j(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Contractor_image', VOID, VOID, [SerializableProperty()]);
    Contractor_imageClass = $;
  }
  return Contractor_imageClass;
}
var Contractor_image_instance;
function Contractor_image_getInstance() {
  if (Contractor_image_instance === VOID)
    new (Contractor_image())();
  return Contractor_image_instance;
}
function Contractor_preferredTitle$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(8);
}
function Contractor_preferredTitle$_get_name_$ref_ximspe() {
  return (p0) => p0.k20();
}
function Contractor_preferredTitle$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[8];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Contractor_preferredTitle$_get_serializer_$ref_pytbmz() {
  return (p0) => p0.j2j();
}
function Contractor_preferredTitle$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(8);
}
function Contractor_preferredTitle$_get_annotations_$ref_7jbcjd() {
  return (p0) => p0.bz();
}
var Contractor_preferredTitleClass;
function Contractor_preferredTitle() {
  if (Contractor_preferredTitleClass === VOID) {
    class $ {
      constructor() {
        Contractor_preferredTitle_instance = this;
        var tmp = this;
        tmp.v5n_1 = lazy(Contractor_preferredTitle$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.w5n_1 = lazy(Contractor_preferredTitle$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.x5n_1 = lazy(Contractor_preferredTitle$annotations$delegate$lambda);
        this.y5n_1 = PreferredTitle_Contractor_getInstance();
        this.z5n_1 = 'PreferredTitle.Contractor';
      }
      k20() {
        var tmp0 = this.v5n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Contractor_preferredTitle$_get_name_$ref_ximspe(), null);
        return tmp0.f2();
      }
      u5i(receiver) {
        return receiver.d5j_1;
      }
      m2j(receiver) {
        return this.u5i(receiver instanceof Contractor() ? receiver : THROW_CCE());
      }
      a5o(receiver, value) {
        return receiver.y5j(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Contractor() ? receiver : THROW_CCE();
        return this.a5o(tmp, value instanceof PreferredTitle() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.w5n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Contractor_preferredTitle$_get_serializer_$ref_pytbmz(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.x5n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Contractor_preferredTitle$_get_annotations_$ref_7jbcjd(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Contractor_preferredTitle', VOID, VOID, [SerializableProperty()]);
    Contractor_preferredTitleClass = $;
  }
  return Contractor_preferredTitleClass;
}
var Contractor_preferredTitle_instance;
function Contractor_preferredTitle_getInstance() {
  if (Contractor_preferredTitle_instance === VOID)
    new (Contractor_preferredTitle())();
  return Contractor_preferredTitle_instance;
}
function Contractor_status$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(24);
}
function Contractor_status$_get_name_$ref_t7qka1() {
  return (p0) => p0.k20();
}
function Contractor_status$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[24];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Contractor_status$_get_serializer_$ref_lzjkpc() {
  return (p0) => p0.j2j();
}
function Contractor_status$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(24);
}
function Contractor_status$_get_annotations_$ref_clknf8() {
  return (p0) => p0.bz();
}
var Contractor_statusClass;
function Contractor_status() {
  if (Contractor_statusClass === VOID) {
    class $ {
      constructor() {
        Contractor_status_instance = this;
        var tmp = this;
        tmp.b5o_1 = lazy(Contractor_status$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.c5o_1 = lazy(Contractor_status$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.d5o_1 = lazy(Contractor_status$annotations$delegate$lambda);
        this.e5o_1 = ContractorStatus_Registering_getInstance();
        this.f5o_1 = 'ContractorStatus.Registering';
      }
      k20() {
        var tmp0 = this.b5o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Contractor_status$_get_name_$ref_t7qka1(), null);
        return tmp0.f2();
      }
      u5i(receiver) {
        return receiver.t5j_1;
      }
      m2j(receiver) {
        return this.u5i(receiver instanceof Contractor() ? receiver : THROW_CCE());
      }
      g5o(receiver, value) {
        return receiver.y5j(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Contractor() ? receiver : THROW_CCE();
        return this.g5o(tmp, value instanceof ContractorStatus() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.c5o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Contractor_status$_get_serializer_$ref_lzjkpc(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.d5o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Contractor_status$_get_annotations_$ref_clknf8(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Contractor_status', VOID, VOID, [SerializableProperty()]);
    Contractor_statusClass = $;
  }
  return Contractor_statusClass;
}
var Contractor_status_instance;
function Contractor_status_getInstance() {
  if (Contractor_status_instance === VOID)
    new (Contractor_status())();
  return Contractor_status_instance;
}
function Contractor_paymentId$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(25);
}
function Contractor_paymentId$_get_name_$ref_7zdk8s() {
  return (p0) => p0.k20();
}
function Contractor_paymentId$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[25];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Contractor_paymentId$_get_serializer_$ref_j4ea97() {
  return (p0) => p0.j2j();
}
function Contractor_paymentId$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(25);
}
function Contractor_paymentId$_get_annotations_$ref_ue0lcf() {
  return (p0) => p0.bz();
}
var Contractor_paymentIdClass;
function Contractor_paymentId() {
  if (Contractor_paymentIdClass === VOID) {
    class $ {
      constructor() {
        Contractor_paymentId_instance = this;
        var tmp = this;
        tmp.h5o_1 = lazy(Contractor_paymentId$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.i5o_1 = lazy(Contractor_paymentId$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.j5o_1 = lazy(Contractor_paymentId$annotations$delegate$lambda);
        this.k5o_1 = null;
        this.l5o_1 = 'null';
      }
      k20() {
        var tmp0 = this.h5o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Contractor_paymentId$_get_name_$ref_7zdk8s(), null);
        return tmp0.f2();
      }
      u5i(receiver) {
        return receiver.u5j_1;
      }
      m2j(receiver) {
        return this.u5i(receiver instanceof Contractor() ? receiver : THROW_CCE());
      }
      j5l(receiver, value) {
        return receiver.y5j(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Contractor() ? receiver : THROW_CCE();
        return this.j5l(tmp, (value == null ? true : typeof value === 'string') ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.i5o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Contractor_paymentId$_get_serializer_$ref_j4ea97(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.j5o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Contractor_paymentId$_get_annotations_$ref_ue0lcf(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Contractor_paymentId', VOID, VOID, [SerializableProperty()]);
    Contractor_paymentIdClass = $;
  }
  return Contractor_paymentIdClass;
}
var Contractor_paymentId_instance;
function Contractor_paymentId_getInstance() {
  if (Contractor_paymentId_instance === VOID)
    new (Contractor_paymentId())();
  return Contractor_paymentId_instance;
}
function Contractor_created$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(26);
}
function Contractor_created$_get_name_$ref_ete2id() {
  return (p0) => p0.k20();
}
function Contractor_created$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[26];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Contractor_created$_get_serializer_$ref_jyo40e() {
  return (p0) => p0.j2j();
}
function Contractor_created$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(26);
}
function Contractor_created$_get_annotations_$ref_yi5y0m() {
  return (p0) => p0.bz();
}
var Contractor_createdClass;
function Contractor_created() {
  if (Contractor_createdClass === VOID) {
    class $ {
      constructor() {
        Contractor_created_instance = this;
        var tmp = this;
        tmp.m5o_1 = lazy(Contractor_created$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.n5o_1 = lazy(Contractor_created$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.o5o_1 = lazy(Contractor_created$annotations$delegate$lambda);
        var tmp_2 = this;
        // Inline function 'com.lightningkite.now' call
        tmp_2.p5o_1 = get_default(Companion_instance_0).d1m();
        this.q5o_1 = 'now()';
      }
      k20() {
        var tmp0 = this.m5o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Contractor_created$_get_name_$ref_ete2id(), null);
        return tmp0.f2();
      }
      u5i(receiver) {
        return receiver.v5j_1;
      }
      m2j(receiver) {
        return this.u5i(receiver instanceof Contractor() ? receiver : THROW_CCE());
      }
      r5o(receiver, value) {
        return receiver.y5j(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Contractor() ? receiver : THROW_CCE();
        return this.r5o(tmp, value instanceof Instant() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.n5o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Contractor_created$_get_serializer_$ref_jyo40e(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.o5o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Contractor_created$_get_annotations_$ref_yi5y0m(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Contractor_created', VOID, VOID, [SerializableProperty()]);
    Contractor_createdClass = $;
  }
  return Contractor_createdClass;
}
var Contractor_created_instance;
function Contractor_created_getInstance() {
  if (Contractor_created_instance === VOID)
    new (Contractor_created())();
  return Contractor_created_instance;
}
function Contractor_readBy$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(27);
}
function Contractor_readBy$_get_name_$ref_76txr8() {
  return (p0) => p0.k20();
}
function Contractor_readBy$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[27];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function Contractor_readBy$_get_serializer_$ref_1fbq6j() {
  return (p0) => p0.j2j();
}
function Contractor_readBy$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(27);
}
function Contractor_readBy$_get_annotations_$ref_aqbfu7() {
  return (p0) => p0.bz();
}
var Contractor_readByClass;
function Contractor_readBy() {
  if (Contractor_readByClass === VOID) {
    class $ {
      constructor() {
        Contractor_readBy_instance = this;
        var tmp = this;
        tmp.s5o_1 = lazy(Contractor_readBy$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.t5o_1 = lazy(Contractor_readBy$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.u5o_1 = lazy(Contractor_readBy$annotations$delegate$lambda);
        this.v5o_1 = emptySet();
        this.w5o_1 = 'emptySet()';
      }
      k20() {
        var tmp0 = this.s5o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, Contractor_readBy$_get_name_$ref_76txr8(), null);
        return tmp0.f2();
      }
      u5i(receiver) {
        return receiver.w5j_1;
      }
      m2j(receiver) {
        return this.u5i(receiver instanceof Contractor() ? receiver : THROW_CCE());
      }
      x5o(receiver, value) {
        return receiver.y5j(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof Contractor() ? receiver : THROW_CCE();
        return this.x5o(tmp, (!(value == null) ? isInterface(value, KtSet()) : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.t5o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, Contractor_readBy$_get_serializer_$ref_1fbq6j(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.u5o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, Contractor_readBy$_get_annotations_$ref_aqbfu7(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'Contractor_readBy', VOID, VOID, [SerializableProperty()]);
    Contractor_readByClass = $;
  }
  return Contractor_readByClass;
}
var Contractor_readBy_instance;
function Contractor_readBy_getInstance() {
  if (Contractor_readBy_instance === VOID)
    new (Contractor_readBy())();
  return Contractor_readBy_instance;
}
//region block: exports
export {
  get__id as get__id44zpbhzp4qxe,
  get_address as get_addressidmncntp3o5q,
  get_annualRevenue as get_annualRevenue2ut1l18ty4ija,
  get_averageJobSize as get_averageJobSizeaccwtlg964jf,
  get_contactAddress as get_contactAddress3g7cmdnh6wwi4,
  get_contactEmail as get_contactEmail1hq0is5lnk4tx,
  get_contactFirstName as get_contactFirstName4zsaw4v0liuh,
  get_contactLastName as get_contactLastNamehzwltosy6qkq,
  get_contactPhoneNumber as get_contactPhoneNumberlh8nl8hy5d06,
  get_ein as get_ein66rl36efyxrr,
  get_email as get_email2a1pybafs9t2d,
  get_employeeCount as get_employeeCount270wmkrhxcm14,
  get_entityType as get_entityTypelucy0bhwa1ig,
  get_legalName as get_legalName1h459s03czxpi,
  get_name as get_name166ebenv7vstz,
  get_operationStates as get_operationStates3trs8asfalcha,
  get_otherBusinessData as get_otherBusinessData3m3w5ebpefc27,
  get_owners as get_owners8roouuqxcbjh,
  get_phoneNumber as get_phoneNumber25jme78ksq49l,
  prepareContractorFields as prepareContractorFields189hu1o90mnmf,
  get_stateEntityNumber as get_stateEntityNumber304fqw2g1kjna,
  get_trade as get_trade2rs99f111iqp6,
};
//endregion

//# sourceMappingURL=ContractorFields.mjs.map
